import { useEffect } from "react";

/**
 * Global keyboard shortcuts.
 *   Space       → play/pause
 *   ArrowLeft   → previous track (or seek to 0 if > 3s into track)
 *   ArrowRight  → next track
 *   /           → focus search input
 *   Esc         → close open modal (handled by caller)
 * Never hijacks when the user is typing into an input / textarea.
 */
export default function useKeyboardShortcuts({ onPlayPause, onNext, onPrev, onFocusSearch, onEscape } = {}) {
  useEffect(() => {
    const handler = (e) => {
      const t = e.target;
      const tag = (t?.tagName || "").toLowerCase();
      const isEditable = tag === "input" || tag === "textarea" || tag === "select" || t?.isContentEditable;

      // "/" focuses search even when nothing is focused
      if (e.key === "/" && !isEditable) {
        e.preventDefault();
        onFocusSearch?.();
        return;
      }

      if (e.key === "Escape") {
        onEscape?.();
        return;
      }

      if (isEditable) return;

      if (e.code === "Space") {
        e.preventDefault();
        onPlayPause?.();
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        onPrev?.();
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        onNext?.();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onPlayPause, onNext, onPrev, onFocusSearch, onEscape]);
}
